module.exports = __webpack_public_path__ + "img/rise.ecebba02.jpg";